const Request = require('@/repositories/request')
const qs = require('qs')
class EducationalStatuses extends Request {
  /**
   *
   * @param {int} id
   * @returns {*}
   */
  findOne(id) {
    return this.$strapi['$experience-educational-statuses'].findOne(id)
  }

  /**
   *
   * @param {Object} params
   * @return {*}
   */
  findAll(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return this.$strapi['$experience-educational-statuses'].find(
      stringifyParams
    )
  }
}

module.exports = EducationalStatuses
